<template>
  <div
    v-if="loaded"
  >
    <div
      class="header blur"
    >
      <div
        v-if="playlist.image"
        :style="{ backgroundImage: 'url(' + playlist.image + ')' }"
        class="bg-image"
      />
      <div
        v-if="!playlist.image"
        class="bg-image"
      />
    </div>
    <div class="container">
      <div class="gutter">
        <div class="columns is-vcentered">
          <div class="column is-6">
            <h2 class="subtitle is-marginless text color-red">
              {{ playlist.track_count }} tracks
            </h2>
            <h1 class="title is-1 text color-white">
              {{ playlist.name }}
            </h1>
            <p
              v-if="playlist.description"
              class="text extra-large color-overlay"
              style="max-height: 120px; overflow: hidden;"
            >
              {{ playlist.description }}
            </p>
          </div>
          <div class="column" />
          <div class="column is-narrow playlist-cover is-hidden-mobile">
            <img :src="playlist.image">
          </div>
        </div>
      </div>
      <div class="box is-large gutter">
        <h3 class="title is-3">
          Tracks
        </h3>
        <track-list-item
          v-for="track in playlist.tracks"
          :key="track.pk"
          :track="track"
        />
      </div>
    </div>
  </div>
</template>

<script>
import playlistsClient from '@/api/playlists.js'
import TrackListItem from '@/components/TrackListItem.vue'

export default {
  name: 'PlaylistDetail',

  components: {
    TrackListItem
  },

  props: {
    playlistId: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      loaded: false,
      playlist: null
    }
  },

  created () {
    playlistsClient.retrieve(this.playlistId)
      .then((response) => {
        this.playlist = response.data
        if (this.playlist.tracks.length > 0) {
          this.$store.dispatch('player/loadTracks', this.playlist.tracks)
        }
        this.loaded = true
      })
      .catch(error => {
        if (error.response.status === 404) {
          this.$router.push({ name: 'not-found' })
        }
      })
  },

  metaInfo () {
    if (this.playlist) {
      let url = window.location.origin
      const path = this.$route.path
      if (path !== '/') {
        url += path
      }
      const title = `${this.playlist.name} | Music Licensing`
      const description = this.playlist.description || ''

      return {
        title,
        meta: [
          { name: 'description', content: description },
          { property: 'og:url', content: url },
          { property: 'og:title', content: title },
          { property: 'og:description', content: description },
          { property: 'og:image', content: this.playlist.image || '/img/sonata-meta.png' },
          { name: 'twitter:card', content: 'website' }
        ]
      }
    } else {
      return {
        title: 'Music Licensing'
      }
    }
  }
}
</script>

<style scoped lang="scss">
.header {
  height: 410px;
}
.column.playlist-cover img {
  max-height: 216px;
  margin-bottom: 20px;
}
</style>
